import { Typography } from '@mui/material';

import { BundleChargingModel } from 'modules/billing/types';
import { IProgressBarProps } from 'modules/common/components/ProgressBar';
import { useIsSMDown } from 'uiKit/Theme/useTheme';
import { useTranslation } from 'modules/i18n/hooks/useTranslation';

import { FreemiumAllowanceActivatingLabel } from '../FreemiumAllowanceActivatingLabel';
import { bundleProgressLabelTranslation } from './translation';
import { useBundleProgressLabelStyles } from './useBundleProgressLabelStyles';

export interface BundleProgressLabelProps {
  chargingModel: BundleChargingModel;
  color?: IProgressBarProps['color'];
  isShortened?: boolean;
}

export const BundleProgressLabel = ({
  chargingModel,
  color,
  isShortened,
}: BundleProgressLabelProps) => {
  const isMobile = useIsSMDown();

  const shortened = isShortened || isMobile;
  const labelVariant = shortened ? 'body4' : 'body3';

  const { classes } = useBundleProgressLabelStyles(shortened);

  const { keys, t } = useTranslation(bundleProgressLabelTranslation);

  return (
    <Typography
      className={classes.root}
      color={color ? `${color}.main` : 'textSecondary'}
      component="div"
      variant={labelVariant}
    >
      <FreemiumAllowanceActivatingLabel isShortened={shortened} />
      {t(keys.used, { percent: chargingModel.usage.percent })}
    </Typography>
  );
};
